import { Badge } from '@journ/ui/badge'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@journ/ui/card'
import { useCurrentUser } from '@/features/auth/hooks/use-current-user'
import { useIntlayer } from 'react-intlayer'

const PasswordCard = () => {
	const content = useIntlayer('security-settings')

	return (
		<Card>
			<CardHeader>
				<CardTitle>{content.password.title}</CardTitle>
				<CardDescription>{content.password.description}</CardDescription>
			</CardHeader>
			<CardContent>
				<p className='text-sm text-606060'>{content.password.body}</p>
			</CardContent>
		</Card>
	)
}

const MfaCard = () => {
	const content = useIntlayer('security-settings')

	return (
		<Card>
			<CardHeader>
				<div className='flex items-center justify-between gap-4'>
					<div className='space-y-1'>
						<CardTitle>{content.mfa.title}</CardTitle>
						<CardDescription>{content.mfa.description}</CardDescription>
					</div>
					<Badge variant='outline'>{content.mfa.status}</Badge>
				</div>
			</CardHeader>
			<CardContent>
				<p className='text-sm text-606060'>{content.mfa.body}</p>
			</CardContent>
		</Card>
	)
}

const SessionCard = () => {
	const content = useIntlayer('security-settings')
	const { user } = useCurrentUser()
	const displayName = user?.fullName ?? content.session.fallbackName.value

	return (
		<Card>
			<CardHeader>
				<CardTitle>{content.session.title}</CardTitle>
				<CardDescription>{content.session.description}</CardDescription>
			</CardHeader>
			<CardContent className='space-y-3 text-sm'>
				<div className='flex items-center justify-between gap-4'>
					<span className='text-606060'>{content.session.signedInAs}</span>
					<span className='font-medium'>{displayName}</span>
				</div>
				<div className='flex items-center justify-between gap-4'>
					<span className='text-606060'>{content.session.email}</span>
					<span className='font-medium'>{user?.email}</span>
				</div>
				<div className='flex items-center justify-between gap-4'>
					<span className='text-606060'>{content.session.role}</span>
					<span className='font-medium capitalize'>{user?.companyRole}</span>
				</div>
			</CardContent>
		</Card>
	)
}

const SecuritySettings = () => (
	<div className='space-y-6 mt-4'>
		<PasswordCard />
		<MfaCard />
		<SessionCard />
	</div>
)

export { SecuritySettings }
